import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import Container from '../../Container/Container';
import styles from '../Header.module.scss';
import { NavLink } from 'react-router-dom';
const SubHeader = ({ data }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.elementBottom, 'd-flex justify-content-center') }, { children: _jsx(Container, { children: _jsx("div", Object.assign({ className: cn(styles.wrapper, 'd-flex') }, { children: data.map(({ name, link: href, disabled, parent }, index) => (_jsx(NavLink, Object.assign({ className: ({ isActive }) => cn(styles.elem, {
                        [styles.active]: isActive,
                        [styles.isDisabled]: disabled
                    }), to: href }, { children: name }), index))) })) }) })));
};
export default SubHeader;
